import {UPLOAD_EXTENSION_BY_MIME} from '../constants';
import {UPLOAD_IMAGE_MIME_TYPES, type UploadImageMimeType} from '../types';

const DEFAULT_BASE_NAME = 'image';
const EXTENSION_PATTERN = /\.[^./\\]+$/;

export const toUploadImageMimeType = (mimeType: string): UploadImageMimeType | null =>
  UPLOAD_IMAGE_MIME_TYPES.find(candidate => candidate === mimeType) ?? null;

/** `IMG_0001.HEIC` + `image/jpeg` → `IMG_0001.jpg`; names without a base become `image.<ext>`. */
export const withExtension = (name: string, mimeType: string): string => {
  const uploadMimeType = toUploadImageMimeType(mimeType);
  if (uploadMimeType === null) {
    return name;
  }
  const base = name.replace(EXTENSION_PATTERN, '').trim();
  return `${base.length === 0 ? DEFAULT_BASE_NAME : base}.${UPLOAD_EXTENSION_BY_MIME[uploadMimeType]}`;
};
